import {
	faCheckCircle,
	faHouseChimney,
	faWarning,
} from '@fortawesome/pro-duotone-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, Button, Typography } from '@mui/material';

const GoHome = () => {
	return (
		<Button
			variant="outlined"
			startIcon={<FontAwesomeIcon icon={faHouseChimney} />}
			onClick={() => {
				location.href = '/';
			}}
		>
			Go Home
		</Button>
	);
};

export const FullPageMessage = ({
	message,
	secondaryText,
	state,
	showGoHome,
}: {
	message: string;
	secondaryText?: string;
	state?: 'error' | 'success';
	showGoHome?: boolean;
}) => {
	return (
		<Box
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: 2,
			}}
		>
			{state === 'error' && (
				<FontAwesomeIcon icon={faWarning} color="darkred" size="3x" />
			)}
			{state === 'success' && (
				<span className="fa-layers fa-fw fa-3x">
					<FontAwesomeIcon icon={faCheckCircle} color="darkgreen" />
					<FontAwesomeIcon icon={faSpinnerThird} spin />
				</span>
			)}
			<Typography variant="h5">{message}</Typography>
			{secondaryText && <Typography variant="h6">{secondaryText}</Typography>}
			{showGoHome && (
				<Box>
					<GoHome />
				</Box>
			)}
		</Box>
	);
};
